"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
const class_validator_1 = require("class-validator");
const mocks_1 = require("../../mocks");
const property_1 = require("../../decorators/property");
const admin_1 = require("../admin/admin");
const user_1 = require("../user/user");
class Notification extends mocks_1.Model {
}
exports.Notification = Notification;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], Notification.prototype, "title", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], Notification.prototype, "body", void 0);
__decorate([
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], Notification.prototype, "successCount", void 0);
__decorate([
    (0, property_1.Property)({ type: mocks_1.ObjectId, index: true }),
    __metadata("design:type", String)
], Notification.prototype, "senderId", void 0);
__decorate([
    (0, property_1.Property)(),
    __metadata("design:type", String)
], Notification.prototype, "state", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], Notification.prototype, "link", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)({ type: mocks_1.ObjectId, required: false, index: true }),
    __metadata("design:type", String)
], Notification.prototype, "recipientId", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'senderId', ref: 'Admin' }),
    __metadata("design:type", admin_1.Admin)
], Notification.prototype, "sender", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'recipientId', ref: 'User' }),
    __metadata("design:type", user_1.User)
], Notification.prototype, "recipient", void 0);
